export const sortObject = (object, sortFunc) => {
	return Object.keys(object).sort(sortFunc).reduce((o, key) => ({...o, [key]: object[key]}), {})
};

export default sortObject;